import React from 'react';

interface FormSectionProps {
  icon?: string;
  title: string;
  children: React.ReactNode;
  className?: string;
}

const FormSection: React.FC<FormSectionProps> = ({ icon, title, children, className = '' }) => {
  return (
    <div className={`space-y-3 sm:space-y-5 ${className}`}>
      {/* Section Header */}
      <div className="flex items-end justify-between space-x-2 sm:space-x-3">
        <div className="flex items-end space-x-2 sm:space-x-3 pl-3 sm:pl-10 md:pl-12">
          {icon && (
            <div className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 flex items-center justify-center -ml-3 sm:-ml-10 md:-ml-12 flex-shrink-0">
              <img src={icon} alt={`${title} icon`} className="w-full h-full object-contain" />
            </div>
          )}
          <h3 className="text-sm sm:text-base md:text-lg font-bold uppercase text-white">
            {title}
          </h3>
        </div>
      </div>

      {/* Section Content */}
      <div className="space-y-3 sm:space-y-4 px-3 sm:pl-10 md:pl-12">{children}</div>
    </div>
  );
};

export default FormSection;
